import { css } from '@emotion/react'
import React, { type ComponentProps } from 'react'

import { Pog } from './Pog'

type Props = {
  /**
   * Value to show in `NumberPog`.
   * For sequential lists: this number should not exceed 9 steps.
   * For large numbers, 2+ digits: this component will stretch into a pill shape.
   */
  number: number
} & Pick<
  ComponentProps<typeof Pog>,
  | 'backgroundColorOverride'
  | 'foregroundColorOverride'
  | 'isDisabled'
  | 'overrideRootStyles'
>

/**
 * Number Pogs are a mini version of the Pog component specifically used to represent numbered steps or counts throughout Robinhood.
 * For numbered steps please do not exceed 9 steps.
 */
export function NumberPog({
  isDisabled = false,
  number,
  overrideRootStyles,
  ...rest
}: Props) {
  return (
    <Pog
      {...rest}
      isDisabled={isDisabled}
      overrideRootStyles={css(overrideRootStyles, {
        boxSizing: 'border-box',
        height: 24,
        minWidth: 24,
        paddingLeft: 8,
        paddingRight: 8,
        width: 'auto',
      })}
      size="standard"
      text={String(number)}
    />
  )
}
